export default "__VITE_ASSET__L8lIEI09__"